<template>
  <div class="main">
    <img src="/checkin/backgroud_top.jpg" style="width: 100%; height: auto">
<!--  <div style="color:white">-->
    <div>
<!--      QRCode:{{memberUUID}}-->
      <div v-if="msg">
        {{msg}}
      </div>
      <div v-else>
<!--        <h1>您的資料</h1>-->
        <table class="table table-hover" style="border: 0px">
          <tbody>
<!--          <tr>-->
<!--            <td ><p class="label"></p> <p class="text">{{formData.Id}}</p></td>-->
<!--          </tr>-->
          <tr>
            <td ><p class="label">姓名:</p> <p class="text">{{formData.Name}}</p></td>
          </tr>
          <tr>
            <td ><p class="label">英文名:</p> <p class="text">{{formData.EName}}</p></td>
          </tr>
          <tr>
            <td ><p class="label">所屬扶輪社:</p> <p class="text">{{formData.Group}}</p></td>
          </tr>
          <tr>
            <td ><p class="label">桌號:</p> <p class="text"></p>{{formData.TableNo}}</td>
          </tr>
          <tr>
            <td ><p class="label">車號:</p> <p class="text"><input type="text" class="form-control"  v-model="formData.CarNo" placeholder="" style="max-width: 150px"></p>
              <a role="button" class="btn btn-primary" href="#"  @click="btnSave">儲存</a>
            </td>

          </tr>


          </tbody>
        </table>

        <h2>參加議程</h2>
        <UIEventItemsForMemberCheckIn :member="formData" v-if="formData.EventSystemId" ></UIEventItemsForMemberCheckIn>
      </div>
    </div>

    <img src="/checkin/backgroud_footer.jpg" style="width: 100%; height: auto">
  </div>
</template>

<script>
import UIEventItemsForMemberCheckIn from "@/views/checkInAdmin/Event/UIEventItemsForMemberCheckIn";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import util from "@/util/util";
import checkInDeclare from "@/views/checkInAdmin/js/checkInDeclare";
/**

 **/


export default {
  components: {UIEventItemsForMemberCheckIn},
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      memberUUID:"",
      msg:"",
      EventSystemId:"",
    };
  },
  methods: {
    async loadData() {
      this.memberUUID=checkInDeclare.GetLocalMemberId();

      if (this.memberUUID){
        let that=this;

        let loader=util.ShowLoading(this);

        apiCheckIn.api_Client_MemberInfo_uuid(this.memberUUID).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,that.formData);
          that.EventSystemId=that.formData.EventSystemId;

          util.HideLoading(loader);
        });
      }else{
        this.msg="訊息:請用相機，掃描您名牌上的QR Code";
      }

    },
    btnSave(){
      let that=this;

      let loader=util.ShowLoading(this);

      apiCheckIn.api_Member_Save_CarNo(that.memberUUID,that.EventSystemId,that.formData.CarNo).then((data)=>{
        alert("儲存車號成功");
        util.HideLoading(loader);
      });
    }
  },
  mounted() {
    //this.loadData()
    let uuid=this.$route.query.id;

    if (uuid){
      uuid=uuid.toString();
      checkInDeclare.SetLocalMemberId(uuid);
      this.memberUUID=uuid;
    }

    this.loadData();

  },
}
</script>

<style scoped>
h2{
  color:#fefe02;
}

.label{
  margin-left: 10px;
  color:#fefe02;
  display: inline-block;
}
.text{
  color:white;
  display: inline-block;
}

.main{
  /*background-image: url("/checkin/background0.jpg");*/
  /*!*background-position: center;*!*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/

  background-color: #00375e;
}
.table{
  color:#fefe02;
  background-color:#00375e;
  border-color:#00375e;
}
</style>
